import React from "react";
//import "./Footer.css"; // Falls du Styling möchtest

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        This is a fan site and is not affiliated with Pokémon Unite, the Pokémon Company, 
        nor the developers nor any rights holders of the game.
      </p>
      <p>© 2025 Poke-meta.</p>
    </footer>
  );
};

export default Footer;
